import { collection, doc, getDocs, addDoc, updateDoc, deleteDoc, query, where, getFirestore } from 'firebase/firestore';
// import { db } from '../../config/firebase';
import { COLLECTIONS } from './collections';
import { Table, TableCategory } from '../../types';

export const tablesService = {
  async getAll(): Promise<Table[]> {
    const db = getFirestore();
    const querySnapshot = await getDocs(collection(db, COLLECTIONS.TABLES));
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Table[];
  },

  async add(table: Omit<Table, 'id'>): Promise<string> {
    const db = getFirestore();
    const docRef = await addDoc(collection(db, COLLECTIONS.TABLES), table);
    return docRef.id;
  },

  async update(id: string, table: Partial<Omit<Table, 'id'>>): Promise<void> {
    const db = getFirestore();
    await updateDoc(doc(db, COLLECTIONS.TABLES, id), table);
  },

  async remove(id: string): Promise<void> {
    const db = getFirestore();
    await deleteDoc(doc(db, COLLECTIONS.TABLES, id));
  },

  async getByCategory(category: TableCategory): Promise<Table[]> {
    const db = getFirestore();
    const q = query(
      collection(db, COLLECTIONS.TABLES),
      where('category', '==', category)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Table[];
  }
};
